import { useEffect, useState } from 'react'
import { IInfrastructureProject, IInfrastructureProjectObject, InfrastructureProjectType } from '../../../../types/project.types'
import classes from './styles.module.scss'
import generalClasses from '../styles.module.scss'
import { useTranslation } from 'react-i18next';
import Field from '../../../../components/field/field.component';
import { findOptionByValue, isEmpty, t } from '../../../../helpers/utils';
import ReactSelect from 'react-select';
import Documentation from '../../components/documentation.component';
import AdditionalInfo from '../../components/additional-info.component';
import FooterComponent from '../../components/footer.component';
import ImageGrid from '../../components/image-grid.component';
import { useParams } from 'react-router-dom';
import { updateInfrastructureProject } from '../../../../requests/supervisor.request';
import { toast } from 'react-toastify';
import { conditionOptions, yesOrNo } from '../../../../consts/project.const';

interface IProps {
  data: IInfrastructureProjectObject
  loadData: () => void;
}

const baseClass = 'health-tab';
const translationKey = 'projects.infrastructure-projects.health';

const keys: Array<keyof IInfrastructureProject> = [
  'nameRu', 'nameKz', 'constructionYear', 'factInfo', 'power', 'factCondition', 'factLocationRu', 'factLocationKz', 'repairRequired'
]

const HealthTab = ({ data, loadData }: IProps) => {
  const { tab } = useParams<{ tab: string }>();
  const { i18n: { language } } = useTranslation();
  const [formData, setFormData] = useState<IInfrastructureProjectObject>(data);
  const [errors, setErrors] = useState<Record<string, boolean>>({});
  const { kato } = useParams<{ kato: string }>();

  const [isAddingFund, setIsAddingFund] = useState(false);
  const [newFund, setNewFund] = useState<{ labelRu: string; labelKz: string; value: string }>({ labelRu: '', labelKz: '', value: '' });

  const [isAddingInfo, setIsAddingInfo] = useState(false);
  const [newInfo, setNewInfo] = useState<{ labelRu: string; labelKz: string; valueRu: string; valueKz: string }>({ labelRu: '', labelKz: '', valueRu: '', valueKz: '' });

  const [isAddingText, setIsAddingText] = useState(false);
  const [newText, setNewText] = useState({
    textRu: '',
    textKz: ''
  });

  const handleInputChange = (field: string, value: string | number) => {
    if (field === 'constructionYear' && value.toString().length > 4) return;

    setFormData(prev => ({
      ...prev,
      infrastructureEntity: {
        ...prev.infrastructureEntity,
        [field]: value
      }
    }));
  };

  const handleSave = () => {
    if (validateFields()) {
      const body = {
        ...formData.infrastructureEntity,
      }

      updateInfrastructureProject(tab as InfrastructureProjectType, body).then(() => {
        loadData();
        toast.success(t(`admin.success`, language));
      });
    }
  };

  const validateFields = () => {
    setErrors({});
    const newErrors: Record<string, boolean> = {};
    const { infrastructureEntity, images } = formData;

    keys.forEach(key => {
      if (isEmpty(infrastructureEntity[key])) {
        newErrors[key] = true;
      }
    });

    if (infrastructureEntity.documentationStatus === 'HAVE' && infrastructureEntity.repairRequired?.toString() === 'true') {
      ['workStart', 'workEnd', 'requiredFundSourceRu', 'requiredFundSourceKz', 'requiredFundAmount'].forEach(key => {
        if (isEmpty(infrastructureEntity[key as keyof IInfrastructureProject])) {
          newErrors[key] = true;
        }
      })

      infrastructureEntity.requiredFund && Object.entries(infrastructureEntity.requiredFund).forEach(([key, value]) => {
        if (isEmpty(value.value)) {
          newErrors[`requiredFund.${key}-value`] = true;
        }
      });
    }

    infrastructureEntity.additionalFields && Object.entries(infrastructureEntity.additionalFields).forEach(([key, value]) => {
      if (key.includes('text')) {
        newErrors[`additionalFields.${key}.textRu`] = isEmpty(value.textRu);
        newErrors[`additionalFields.${key}.textKz`] = isEmpty(value.textKz);
      } else {
        newErrors[`additionalFields.${key}.valueRu`] = isEmpty(value.valueRu);
        newErrors[`additionalFields.${key}.valueKz`] = isEmpty(value.valueKz);
      }
    });


    // if (!infrastructureEntity.files?.length) {
    //   toast.error('Загрузите фото');
    //   newErrors['files'] = true;
    // }

    setErrors(newErrors);

    return Object.values(newErrors).every(error => !error);
  }

  useEffect(() => {
    if (!data) return;
    setFormData(data);
  }, [data]);

  const renderFields = (lang: 'ru' | 'kz') => {
    const suffix = lang === 'ru' ? 'Ru' : 'Kz';
    const { infrastructureEntity } = formData;

    return <div className={generalClasses[`fields-container`]}>
      <Field
        key={`name${suffix}`}
        label={t('projects.infrastructure-projects.name', lang)}
        value={infrastructureEntity?.[`name${suffix}`] || ''}
        onChange={(value) => {
          handleInputChange(`name${suffix}`, value);
        }}
        type="text"
        required
        error={errors[`name${suffix}`]}
      />

      <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
        {['constructionYear', 'factInfo', 'power'].map(field => {
          const val = infrastructureEntity?.[field as keyof typeof infrastructureEntity];
          const value = val === '' ? '' : val as string | number;
          return (
            <Field
              key={field}
              label={t(`projects.infrastructure-projects.health.${field}`, lang)}
              value={value ?? ''}
              onChange={(newValue) => {
                const val = newValue === '' ? '' : +newValue;
                handleInputChange(field, val);
              }}
              type="number"
              required
              error={errors[field]}
            />
          )
        })}

        <div
          className={`${generalClasses['field-block__label']} ${generalClasses['required']}`}>
          {t(`${translationKey}.factCondition`, lang)}
        </div>
        <ReactSelect
          options={conditionOptions(t, 'projects.infrastructure-projects', lang)}
          value={findOptionByValue(infrastructureEntity?.factCondition, conditionOptions(t, 'projects.infrastructure-projects', lang))}
          onChange={(option) => handleInputChange('factCondition', option?.value || '')}
          placeholder=""
        />
      </div>

      <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
        <Field
          key={`factLocation${suffix}`}
          label={t(`projects.infrastructure-projects.health.factLocation`, lang)}
          value={infrastructureEntity?.[`factLocation${suffix}`] || ''}
          onChange={(newValue) => {
            const val = newValue === '' ? '' : +newValue;
            handleInputChange(`factLocation${suffix}`, val);
          }}
          type="number"
          required
          error={errors[`factLocation${suffix}`]}
          placeholder={t('projects.infrastructure-projects.health.factLocation-placeholder', lang)}
        />
      </div>

      <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
        <div
          className={`${generalClasses['field-block__label']} ${generalClasses['required']}`}>
          {t(`${translationKey}.repairRequired`, lang)}
        </div>
        <ReactSelect
          options={yesOrNo(t, 'projects.infrastructure-projects', lang)}
          value={findOptionByValue(infrastructureEntity?.repairRequired, yesOrNo(t, 'projects.infrastructure-projects', lang))}
          onChange={(option) => handleInputChange('repairRequired', option?.value || '')}
          placeholder=""
        />
      </div>

      {infrastructureEntity?.repairRequired?.toString() === 'true' &&
        <Documentation
          data={formData}
          setData={setFormData}
          lang={lang}
          newFund={newFund}
          setNewFund={setNewFund}
          isAddingFund={isAddingFund}
          setIsAddingFund={setIsAddingFund}
          parentErrors={errors}
        />}

      <AdditionalInfo
        data={formData}
        setData={setFormData}
        lang={lang}
        newText={newText}
        setNewText={setNewText}
        newInfo={newInfo}
        setNewInfo={setNewInfo}
        isAddingText={isAddingText}
        setIsAddingText={setIsAddingText}
        isAddingInfo={isAddingInfo}
        setIsAddingInfo={setIsAddingInfo}
        parentErrors={errors}
      />
    </div>

  }

  if (!data || !formData) return null;
  return (
    kato && <div className={classes[baseClass]}>
      <div className={generalClasses['grid']}>
        {renderFields(language === 'ru' ? 'ru' : 'kz')}
        {renderFields(language === 'ru' ? 'kz' : 'ru')}
      </div>
      <ImageGrid
        kato={+kato}
        imageData={formData.images}
        type={'infrastructure-projects'}
        objectId={formData.infrastructureEntity.id}
        setFormData={setFormData}
      />
      <FooterComponent
        onSave={handleSave}
        validateFields={validateFields}
      />
    </div>
  )
}

export default HealthTab